import ExternalLogger from "../../../logger/ExternalLogger";

const ContactModalController = function ($scope, $state, $modalInstance) {
    /**
     * Logger.
     */
    const logger = ExternalLogger.getInstance("ContactModalController");

    /**
     *  Close modal window
     **/
    $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
    };

    function init() {
        logger.debug("init()");
    }

    init();
};

ContactModalController.$inject = ["$scope", "$state", "$modalInstance"];
export default ContactModalController;
